import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';
import useAuth from 'src/hooks/useAuth';
import Button from '../design-system/Button';
import LoadingPanel from '../LoadingPanel';

const AuthGuard = () => {
  const { t } = useTranslation();
  const { user, isAuthTimedOut } = useAuth();
  const handleReload = useCallback(() => {
    window.parent.postMessage('reload', '*');
  }, []);

  if (!user || Object.keys(user).length <= 1) {
    if (isAuthTimedOut) {
      return (
        <div className="flex flex-col items-center justify-center gap-4 p-8 min-h-[200px]">
          <p className="text-center font-semibold">{t('errors.authLoadFailed')}</p>
          <Button color="info" onClick={handleReload}>
            {t('Reload')}
          </Button>
        </div>
      );
    }
    return <LoadingPanel />;
  }
  return <Outlet />;
};

export default AuthGuard;
